import { format, parseISO } from "date-fns";
import { Clock, MapPin, CalendarDays } from "lucide-react";
import { TYPE_COLOR } from "./constants";

const isUpcoming = (e) => { try { return parseISO(e.date) >= new Date(new Date().toDateString()); } catch { return false; } };

export function UpcomingList({ events, onOpen }) {
  const upcoming = [...events].filter(isUpcoming).sort((a, b) => a.date.localeCompare(b.date)).slice(0, 6);
  return (
    <div>
      <h3 className="font-display font-bold text-sm uppercase tracking-wide text-muted-foreground mb-3 flex items-center gap-2"><CalendarDays className="h-4 w-4 text-primary" /> Upcoming</h3>
      <div className="space-y-2" data-testid="calendar-upcoming">
        {upcoming.length === 0 && <p className="text-sm text-muted-foreground">No upcoming events.</p>}
        {upcoming.map((e) => (
          <button key={e.id} onClick={() => onOpen(e)} className="w-full text-left border border-border bg-card rounded-sm p-3 hover:border-primary transition-colors">
            <div className="flex items-center gap-2 mb-1">
              <span className={`text-[10px] uppercase tracking-wide font-semibold px-1.5 py-0.5 rounded-sm ${TYPE_COLOR[e.type] || "bg-muted"}`}>{e.type}</span>
              <span className="text-xs text-muted-foreground">{format(parseISO(e.date), "MMM d")}</span>
            </div>
            <div className="text-sm font-medium">{e.title}</div>
            <div className="text-xs text-muted-foreground flex items-center gap-2 mt-0.5">
              {e.time && <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{e.time}</span>}
              {e.location && <span className="flex items-center gap-1 truncate"><MapPin className="h-3 w-3" />{e.location}</span>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
